export interface WikiPolarArticle {
  slug: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  metaKeywords: string;
  category: string;
  subcategory: string;
  excerpt: string;
  content: string;
  image: string;
  readTime: string;
  tags: string[];
  date: string;
  author: string;
  authorRole: string;
  faq: Array<{ question: string; answer: string }>;
}

const IMG = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/';

const article1Content = `<p class="text-base md:text-lg leading-[1.8] mb-6">第一次去南极什么时候最好？南极邮轮100人、200人和500人有什么区别？船票应该提前多久预订？会不会晕船？南极半岛、南极圈和南极三岛又应该怎么选？自由旷野旅行结合南极旅行实际规划经验，从旅行季节、邮轮载客量、预订时间以及不同南极航线等方面，整理第一次南极旅行最常见的5个问题，为计划前往南极的旅行者提供参考。</p>
<p class="text-base md:text-lg leading-[1.8] mb-6">南极是世界上旅行门槛相对较高的目的地之一。对于第一次计划南极旅行的人来说，往往还没有开始挑船，就已经被各种专业名词绕晕了。下面，自由旷野旅行从5个最常见的问题开始，系统讲清楚第一次南极旅行需要了解的基础知识。</p>
<div class="my-8 rounded-xl overflow-hidden"><img src="${IMG}20ef5620-dfda-41e6-bef8-330a430cac5c_compressed_polar-01-antarctica-faq-2026-img-002-e2fb06577e.webp" alt="南极冰海与探险邮轮" class="w-full h-auto object-cover" /></div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">一、去南极旅游什么时间最好？</h2>
<p class="text-base md:text-lg leading-[1.8] mb-6">12月—2月都比较推荐。此时，南极天气相对稳定，动物也比较活跃，同时也能看到壮观的冰川。常规南极旅游季主要集中在南半球夏季，每年的10月中旬到次年3月底都可以旅行，但是中间的三个月更好。</p>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">11月：冰雪感更强</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">南极旅游季刚刚开始时，整个世界刚从漫长冬季中苏醒。这一阶段通常可以看到更多积雪和海冰景观，冰雪环境更加完整，冰川最多。部分企鹅开始求偶、筑巢和孵蛋。如果更喜欢冰雪、雪景、纯净感以及南极初夏的荒凉氛围，11月很有吸引力。</p>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">12月：日照时间长，进入核心旅行季</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">进入12月以后，南极逐渐迎来盛夏。白昼时间非常长，冰雪渐融，可选登陆点多，天气条件整体更加适合开展登陆、冲锋艇巡游等户外活动。企鹅繁殖季也进入非常重要的阶段，动物活跃。同时，12月底至元旦前后属于全球旅行旺季，因此热门船只和热门舱位通常比较紧张。</p>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">1月—2月上旬：第一次去南极非常经典的时间</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">1月通常是南极旅行非常受欢迎的月份之一。此时企鹅幼鸟逐渐活跃，野生动物观察机会丰富，日照时间仍然很长，航行难度低，依然有很多登陆点可选。如果第一次去南极，12月至1月通常是比较稳妥的时间选择。</p>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">2月下旬—3月：最佳观鲸时节</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">进入2月下旬以后，部分区域鲸类活动会更加活跃。小企鹅褪毛换羽，鲸鱼巡游捕食。因此，对于尤其关注鲸类以及海上生态的旅行者，2月同样值得考虑。</p>
<div class="my-8 rounded-xl overflow-hidden"><img src="${IMG}32774dbd-60e9-435b-955f-ed0385bf3db9_compressed_polar-01-antarctica-faq-2026-img-003-7baee35f4c.webp" alt="南极海域的鲸鱼" class="w-full h-auto object-cover" /></div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">二、南极邮轮100人、200人、500人有什么区别？</h2>
<p class="text-base md:text-lg leading-[1.8] mb-6">南极探险邮轮与普通海上邮轮最大的区别之一，就是：去南极的核心是下船后的户外活动，比如登陆、冲锋艇巡游、皮划艇等。</p>
<p class="text-base md:text-lg leading-[1.8] mb-6">根据南极旅游相关管理规范，在同一登陆地点，同时登陆岸上的游客通常不得超过100人。这也意味着：船上有多少乘客，会直接影响登陆和活动的组织方式。</p>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">100人左右的小型探险船</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">如果实际参与登陆的游客不超过100人，在条件允许的情况下，可以实现整船游客同时进行登陆活动。它的优势是分组更少、组织效率高、行程灵活性较强。因此，在硬件、船龄、航线等其他条件接近的情况下，小型探险船通常并不便宜，部分精品小船甚至会明显更贵。</p>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">120—200人左右的现代探险邮轮</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">这是目前南极市场非常主流的一类船型。因为登陆人数限制，这类邮轮通常会把游客分组：一部分游客进行陆地登陆，另一部分进行冲锋艇巡游，随后轮换。近年来不少120—150人左右的新型探险邮轮，在船舱面积、公共空间、稳定性以及登陆效率之间取得了不错的平衡。</p>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">500人以上的大型邮轮</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">按照现行南极旅游相关规则，载客超过500人的船舶不得进行游客登陆活动。因此，这类产品通常更接近 Cruise-only，即以船上观光、海上巡航为主，而不是传统意义上的南极探险邮轮体验。</p>
<div class="my-8 rounded-xl overflow-hidden"><img src="${IMG}48fc5c74-ba64-48c1-b938-e48dc09b10aa_compressed_polar-01-antarctica-faq-2026-img-004-9263b7ead3.webp" alt="南极探险邮轮" class="w-full h-auto object-cover" /></div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">三、南极船票需要提前多久预订？</h2>
<p class="text-base md:text-lg leading-[1.8] mb-6">没有绝对统一的答案。但对于希望挑选网红邮轮和舱位的旅行者，自由旷野旅行通常建议：<strong>提前9个月以上预定</strong>。热门的邮轮/航程预定很快。南极行程面向世界售卖，能早定，可选的航线、房型更多。</p>
<p class="text-base md:text-lg leading-[1.8] mb-6">很多船司早鸟比 last minute 还更划算（也有特例，基本是卖得不好的船司）。如果是只想要纯纯性价比 low price 的游客，也完全可以蹲最后一分钟船票。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">四、会不会晕船？</h2>
<p class="text-base md:text-lg leading-[1.8] mb-6">过德雷克海峡，大部分人都会晕船。以我们的经验，大概超过80%游客，有不同程度晕船。</p>
<p class="text-base md:text-lg leading-[1.8] mb-6">德雷克海峡（Drake Passage）位于南美洲南端与南极半岛之间，是绝大多数传统南极半岛航线必须经过的海域。这里也是全球著名的海况复杂区域之一。</p>
<p class="text-base md:text-lg leading-[1.8] mb-6">旅行者经常会听到两个说法：<strong>Drake Lake——德雷克湖</strong>，以及 <strong>Drake Shake——德雷克摇</strong>。前者指风平浪静时，海面可能相对平稳；后者则代表遇到明显风浪时的德雷克海峡。究竟遇到哪一种，很大程度上取决于当时天气和海况。建议还是备上晕船药。</p>
<p class="text-base md:text-lg leading-[1.8] mb-6">如果实在不想晕船，可选飞跃德雷克海峡船票。一般从智利的蓬塔飞乔治王岛，然后再登船游览南极。</p>
<div class="my-8 rounded-xl overflow-hidden"><img src="${IMG}9826c056-6e47-44c4-a36f-93abebf81941_compressed_polar-01-antarctica-faq-2026-img-005-598ea6bd6a.webp" alt="德雷克海峡航行" class="w-full h-auto object-cover" /></div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">五、南极半岛、南极圈、南极三岛有什么区别？</h2>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">1. 南极半岛</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">南极半岛是目前最成熟、也是最经典的南极旅行区域。常规航线通常从阿根廷乌斯怀亚出发，穿越德雷克海峡后抵达南设得兰群岛及南极半岛。常见看点包括：企鹅、鲸类、海豹、巨大冰山、冰川、冲锋艇巡游和南极登陆。整体船期通常约为8—11天，耗时最短。如果第一次去南极、假期有限，希望集中体验最经典的南极自然景观，南极半岛通常是最容易入门的选择。</p>
<div class="my-8 rounded-xl overflow-hidden"><img src="${IMG}f7181d99-5b47-437e-b8b4-85f88f4a3e10_compressed_polar-01-antarctica-faq-2026-img-006-aa6207485d.webp" alt="南极半岛企鹅与冰山" class="w-full h-auto object-cover" /></div>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">2. 进南极圈</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">进入南纬66°34′，是非常明确的地理标识。行程一般11—14天，理论上越往南看到的冰山越多，对海冰和天气条件的依赖也更明显。</p>
<div class="my-8 rounded-xl overflow-hidden"><img src="${IMG}be377ad2-1d53-4f90-84c4-4cfa18a88c7c_compressed_polar-01-antarctica-faq-2026-img-007-bed8fcda6f.webp" alt="进入南极圈的冰山景观" class="w-full h-auto object-cover" /></div>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">3. 南极三岛</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">一般指：福克兰群岛（马尔维纳斯群岛）+ 南乔治亚岛 + 南极半岛。这类行程通常需要约18—22天甚至更长时间。它最大的吸引力之一是：南乔治亚岛。这里拥有世界上极具代表性的王企鹅聚集地之一，大规模企鹅群落带来的视觉冲击，与南极半岛完全不同。</p>
<p class="text-base md:text-lg leading-[1.8] mb-6">与此同时，南乔治亚岛也是南极探险史的重要地点。著名极地探险家欧内斯特·沙克尔顿（Ernest Shackleton）长眠于此，因此部分行程还可以接触南极探险历史相关的人文内容。对于摄影爱好者、野生动物爱好者以及已经去过南极半岛，希望进行第二次深度极地旅行的人来说，南极三岛尤其值得关注。</p>
<p class="text-base md:text-lg leading-[1.8] mb-6">需要注意的是，南乔治亚岛的具体登陆地点及野生动物区域管理可能受到禽流感、生物安全规定等因素影响，实际活动必须以当季官方规定和探险队安排为准。</p>
<div class="my-8 rounded-xl overflow-hidden"><img src="${IMG}48752033-4441-4808-ac4f-18387808a0de_compressed_polar-01-antarctica-faq-2026-img-008-738ea80a06.webp" alt="南乔治亚岛王企鹅群" class="w-full h-auto object-cover" /></div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">关于自由旷野旅行</h2>
<p class="text-base md:text-lg leading-[1.8] mb-6">自由旷野旅行长期专注非洲Safari与南北极自然旅行，为您提供南北极旅行信息攻略分享、南北极邮轮船票预订，独家折扣分享。</p>
<p class="text-base md:text-lg leading-[1.8] mb-6">自由旷野旅行与银海邮轮（Silversea）、庞洛游轮（Ponant）等全球奢华邮轮品牌保持长期深度合作，第一时间获取最新航线与舱位资源。依托多年高端奢华游轮操作经验，为客户定制涵盖南北极探险、奢华环游及主题航程的专属邮轮之旅。</p>`;

const article1Faq = [
  { question: '第一次去南极，什么时间去最好？', answer: '12月—2月都比较推荐。11月冰雪感更强；12月日照时间长、进入核心旅行季；1月—2月上旬是第一次去南极非常经典的时间，动物活跃、登陆点多；2月下旬—3月是最佳观鲸时节。如果第一次去，12月至1月通常是比较稳妥的选择。' },
  { question: '南极邮轮100人、200人、500人有什么区别？', answer: '南极同一登陆点同时登陆岸上通常不得超过100人。100人左右的小型探险船可实现整船同时登陆，灵活但通常更贵；120—200人现代探险邮轮是主流，需分组轮换登陆；500人以上大型邮轮不得登陆，只能船上观光海上巡航。' },
  { question: '南极船票需要提前多久预订？', answer: '建议提前9个月以上预定。热门邮轮/航程预定很快，能早定可选的航线、房型更多，很多船司早鸟价比 last minute 更划算。如果只追求极致性价比，也可以蹲最后一分钟船票。' },
  { question: '去南极会不会晕船？', answer: '过德雷克海峡大部分人都会晕船，以我们的经验约超过80%游客有不同程度晕船。德雷克海峡海况复杂，可能出现"德雷克湖"（风平浪静）或"德雷克摇"（明显风浪）。建议备上晕船药，实在不想晕船可选飞跃德雷克海峡的船票。' },
];

export const wikiPolarArticles: WikiPolarArticle[] = [
  {
    slug: 'antarctica-faq-2026',
    title: '2026南极旅游常见问题TOP5：最佳时间、邮轮&航线选择指南',
    metaTitle: '2026南极旅游常见问题TOP5：最佳时间、邮轮&航线选择指南 | 自由旷野旅行',
    metaDescription: '第一次去南极什么时候最好？南极邮轮100人、200人、500人有什么区别？船票要提前多久订？自由旷野旅行从旅行季节、邮轮载客量、预订时间及南极半岛、南极圈、南极三岛等航线，整理第一次南极旅行最常见的5个问题。',
    metaKeywords: '南极旅游,2026南极,南极最佳时间,南极邮轮,南极船票,南极航线,南极半岛,南极圈,南极三岛,德雷克海峡,自由旷野旅行',
    category: '极地百科',
    subcategory: '行前指南',
    excerpt: '第一次去南极什么时候最好？南极邮轮100人、200人和500人有什么区别？船票应该提前多久预订？会不会晕船？南极半岛、南极圈和南极三岛又该怎么选？自由旷野旅行整理第一次南极旅行最常见的5个问题，为计划前往南极的旅行者提供参考。',
    content: article1Content,
    image: `${IMG}dc5e75a1-a3e2-477a-8a1f-163ee7dd68ad_compressed_polar-01-antarctica-faq-2026-img-001-2f6226a426.webp`,
    readTime: '12分钟',
    tags: ['南极', '南极邮轮', '2026', '南极航线', '极地旅行'],
    date: '2026-08-31',
    author: 'EVAN',
    authorRole: '资深旅行定制师',
    faq: article1Faq,
  },
];